// extracted by mini-css-extract-plugin
export default {"mediaMediumUp":"(min-width: 48em)","mediaLargeUp":"(min-width: 64em)","container":"I9j-Rpc6GRKHAWEsW-OkbQ==","asset":"g8t1kW694RVYGsEE58jy6w==","img":"vdERnKwyKw1reQxxhutF1g=="};